import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { TabKind } from './apg-copilot-domain';

// The two-tab switcher: Roll positions (runnable) + Zone (read-only) + a reset button AFTER the tabs.
// Dumb/presentational — emits the chosen TabKind and a reset request; the orchestrator owns the active
// state, the reset action and the stale-drift comparison.
//
// Uses the SAME control as the Hedge CoPilot tab switcher: a contained dx-button-group whose selected
// segment is recolored to the CoPilot accent by the shared `copilot-segmented-selected` mixin. The
// refresh button after the tabs mirrors the OPG/HedgeMatrix CoPilot header pattern (whole-dialog reset);
// its `stale` input drives the yellow drift cue.
@Component({
    selector: 'ets-apg-copilot-tab-bar',
    templateUrl: './apg-copilot-tab-bar.component.html',
    styleUrls: ['./apg-copilot-tab-bar.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ApgCopilotTabBarComponent {
    @Input() activeTab: TabKind = 'rollPositions';

    // True while the grid has drifted from what the CoPilot captured at run time -> the refresh button
    // goes yellow (look-only; the click that clears it is the same whole-dialog reset).
    @Input() stale = false;

    @Output() tabChange = new EventEmitter<TabKind>();

    // Whole-dialog reset request (the refresh button). The orchestrator does the actual reset.
    @Output() reset = new EventEmitter<void>();

    readonly tabItems: { id: TabKind; text: string }[] = [
        { id: 'rollPositions', text: 'Roll Positions' },
        { id: 'zone', text: 'Zone' }
    ];

    onItemClick(e: { itemData: { id: TabKind } }): void {
        this.tabChange.emit(e.itemData.id);
    }

    onResetClick(): void {
        this.reset.emit();
    }
}
